const situations = [
  'сотрудник систематически нарушает договорённости, несмотря на ранее данные обещания;',
  'сотрудник манипулирует руководителем: апеллирует к жалости, вине или личным отношениям;',
  'ответственность постоянно перекладывается на других или на самого руководителя;',
  'сотрудник использует эмоциональное давление, чтобы избежать выполнения задачи;',
  'руководитель сталкивается с ультиматумом: «или так, или я ухожу»;',
  'сотрудник отказывается выполнять обоснованное требование, не приводя конструктивных аргументов;',
  'необходимо провести неприятный разговор, который давно откладывался;',
  'необходимо ясно обозначить последствия невыполнения договорённостей.',
];

export default function ToughNegotiations() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Жёсткие переговоры руководителя
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Есть ситуации, когда договориться «по-хорошему» недостаточно — нужна способность сохранять позицию, границы и ответственность за результат
        </p>

        <div className="grid sm:grid-cols-2 gap-3 mb-12 max-w-4xl mx-auto">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-flashlight-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Жёсткость руководителя — это не агрессия и не давление должностью, а способность сохранять позицию, границы и ответственность за результат даже в эмоционально сложных ситуациях.
          </p>
        </div>
      </div>
    </section>
  );
}